
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--time-picker ${
        isMultiple && 'condition-item--time-picker-range'
    } condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElTimePicker
        v-bind="contentProps"
        :disabled="insetDisabled"
        :value="checked"
        class="condition-item__content"
        @input="change"
    ></ElTimePicker>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else>
            <component :is="getNode(postfix, checked)"></component>
        </template>
    </div>
</ElFormItem>
